import React from "react";
import { SelectField, FormItem } from "@tiny/components";

interface BooleanValueProps {
  prefixName: string;
  disabled?: boolean;
}

const BOOLEAN_OPTIONS = [
  { label: "True", value: "true" },
  { label: "False", value: "false" },
];

function BooleanValue(props: BooleanValueProps) {
  const { prefixName, disabled } = props;
  const name = `${prefixName}.value.value`;

  return (
    <FormItem
      name={name}
      rules={{
        required: {
          value: true,
          message: "Required field",
        },
      }}
      watchValue
    >
      <SelectField
        options={BOOLEAN_OPTIONS}
        placeholder="Select value"
        showHelperTextMargin
        disabled={disabled}
      />
    </FormItem>
  );
}

export default BooleanValue;
